import { render, staticRenderFns } from "./SatinalmaIadeariza.vue?vue&type=template&id=5e7d7504&"
import script from "./SatinalmaIadeariza.vue?vue&type=script&lang=js&"
export * from "./SatinalmaIadeariza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports